<template>
  <div>
    <RouterView></RouterView>
  </div>
</template>
